export interface ThemeColors {
  background: string;
  surface: string;
  surfaceAlt: string;
  border: string;
  text: string;
  textMuted: string;
  primary: string;
  onPrimary: string;
  danger: string;
  success: string;
  warning: string;
}

export interface ThemeFontFamily {
  regular: string;
  medium: string;
  semibold: string;
  bold: string;
  heading: string;
}

export interface ThemeTokens {
  colors: ThemeColors;
  spacing: (steps: number) => number;
  radius: { sm: number; md: number; lg: number; pill: number };
  fontSize: { xs: number; sm: number; md: number; lg: number; xl: number };
  fontWeight: { regular: '400'; medium: '500'; semibold: '600'; bold: '700' };
  fontFamily?: ThemeFontFamily;
}

const SPACING_UNIT = 4;

export const defaultColors: ThemeColors = {
  background: '#f5f6f8',
  surface: '#ffffff',
  surfaceAlt: '#eef1f4',
  border: '#d5dbe1',
  text: '#1f2933',
  textMuted: '#6b7784',
  primary: '#0d6efd',
  onPrimary: '#ffffff',
  danger: '#dc3545',
  success: '#198754',
  warning: '#ffc107',
};

export interface CreateThemeOptions {
  primary?: string;
  colors?: Partial<ThemeColors>;
  fontFamily?: ThemeFontFamily;
}

export function createTheme(options?: CreateThemeOptions): ThemeTokens {
  const colors: ThemeColors = {
    ...defaultColors,
    ...(options?.primary ? { primary: options.primary } : {}),
    ...options?.colors,
  };

  return {
    colors,
    spacing: (steps: number) => steps * SPACING_UNIT,
    radius: { sm: 4, md: 8, lg: 16, pill: 999 },
    fontSize: { xs: 12, sm: 14, md: 16, lg: 20, xl: 28 },
    fontWeight: { regular: '400', medium: '500', semibold: '600', bold: '700' },
    fontFamily: options?.fontFamily,
  };
}

export const defaultTheme: ThemeTokens = createTheme();
